// avatar preview stuff
const avatarDelete = document.getElementById('avatar-delete');
const avatarInput = document.getElementById('avatar-selection');
const avatarPreview = document.getElementById('avatar-preview');
if(avatarInput instanceof HTMLInputElement && avatarPreview instanceof HTMLImageElement) {
    let lastAvatarSource = avatarPreview.src;

    if(avatarDelete instanceof HTMLInputElement) {
        avatarDelete.addEventListener('change', ev => {
            // hardcoded thing is little stinky
            avatarPreview.src = avatarDelete.checked ? '/assets/avatar/0' : lastAvatarSource;
        });
    }

    avatarInput.addEventListener('change', ev => {
        if(avatarDelete instanceof HTMLInputElement)
            avatarDelete.checked = false;

        const file = avatarInput.files[0];
        avatarPreview.src = lastAvatarSource = URL.createObjectURL(file);
        avatarPreview.title = file.name;
    });
}

// background preview stuff
const backgroundDisplay = document.querySelector('.js-profile-background-display');
const backgroundInput = document.querySelector('.js-profile-background-input');
if(backgroundDisplay instanceof HTMLDivElement && backgroundInput instanceof HTMLInputElement) {
    const originalBackgroundText = backgroundDisplay.textContent;
    const backgroundAttachOpts = new Set;
    const backgroundAttrs = new Map;
    let backgroundAttach = '';
    let backgroundImage = null;

    const updateBackgroundState = () => {
        const none = backgroundAttach === '';

        for(const name of backgroundAttachOpts)
            if(name !== '')
                document.body.classList.toggle(`main--bg-${name}`, !none && backgroundAttach === name);

        for(const [name, value] of backgroundAttrs)
            document.body.classList.toggle(`main--bg-${name}`, !none && value);

        if(none) {
            document.body.style.setProperty('--site-bg-image', 'initial');
            document.body.style.setProperty('--background-width', 'auto');
            document.body.style.setProperty('--background-height', 'auto');
        } else if(backgroundImage instanceof Image) {
            document.body.style.setProperty('--site-bg-image', `url('${backgroundImage.src}')`);
            document.body.style.setProperty('--background-width', `${backgroundImage.width}px`);
            document.body.style.setProperty('--background-height', `${backgroundImage.height}px`);
        } else {
            document.body.style.removeProperty('--site-bg-image');
            document.body.style.removeProperty('--background-width');
            document.body.style.removeProperty('--background-height');
        }
    };

    for(const input of document.querySelectorAll('.js-profile-background-attach'))
        if(input instanceof HTMLInputElement) {
            backgroundAttachOpts.add(input.value);
            if(input.checked)
                backgroundAttach = input.value;

            input.addEventListener('change', () => {
                if(input.checked)
                    backgroundAttach = input.value;

                updateBackgroundState();
            });
        }

    for(const input of document.querySelectorAll('.js-profile-background-attr'))
        if(input instanceof HTMLInputElement) {
            backgroundAttrs.set(input.value, input.checked);

            input.addEventListener('change', () => {
                backgroundAttrs.set(input.value, input.checked);
                updateBackgroundState();
            });
        }

    backgroundInput.addEventListener('change', ev => {
        if(ev.target.files.length > 0) {
            const file = ev.target.files[0];
            backgroundDisplay.textContent = file.name;

            backgroundImage = new Image;
            backgroundImage.onload = () => { updateBackgroundState(); };
            backgroundImage.onerror = () => {
                backgroundImage = null;
                updateBackgroundState();
            };
            backgroundImage.src = URL.createObjectURL(file);
        } else {
            backgroundDisplay.textContent = originalBackgroundText;
            updateBackgroundState();
        }
    });

    updateBackgroundState();
}
